module.exports = __webpack_public_path__ + "assets/144d5307287d123c14d1098cd19b102d.mp3";